import React from 'react';

const Service = ({ service }) => {

    const { img, title, des } = service;

    return (
        <div className='md:w-full border-2 border-white  hover:border-2 hover:border-primary rounded-2xl w-5/6 mx-auto custom_shadow text-center p-4'
            data-aos="fade-up"
            data-aos-duration="800"
        >
            <img src={img} className='w-20 h-20 mx-auto my-3' alt="service_Img" />
            <h2 className='text-2xl font-bold mb-2'>{title}</h2>
            <p className='text-medium text-gray-500'>{des}</p>
        </div>
    );
};

export default Service;